import { createApiRequest } from "@/lib/api/createApiService";
import { ESG_ENDPOINTS } from "./esg.endpoints";
import { apiClient } from "@/lib/api";

export const esgService = {
  getFrameworks: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.FRAMEWORKS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getDisclosures: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.DISCLOSURES,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getQuantitativeTargets: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  bulkSaveQuantitativeTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS_BULK,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  seedQuantitativeTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS_SEED,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  deleteQuantitativeTargets: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS,
      method: "DELETE",
      body: params,
      ...options,
    });
  },

  getCarbonTargets: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.CARBON_TARGETS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  saveCarbonTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.CARBON_TARGETS,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  getReportList: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORTS(),
      method: "GET",
      body: params,
      ...options,
    });
  },

  getReport: async (reportId, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORTS(reportId),
      method: "GET",
      ...options,
    });
  },

  createReport: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORTS(),
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateReport: async (reportId, payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORTS(reportId),
      method: "PUT",
      body: payload,
      ...options,
    });
  },

  deleteReport: async (id, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORTS(id),
      method: "DELETE",
      ...options,
    });
  },

  duplicateReport: async (id, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORT_DUPlICATE(id),
      method: "POST",
      ...options,
    });
  },

  uploadFile: async (reportId, formData) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORT_FILES(reportId),
      method: "POST",
      body: formData,
      isFormData: true,
    });
  },

  downloadFile: async (reportId, proof) => {
    if (!reportId) return;
    const { data } = await apiClient.get(
      ESG_ENDPOINTS.ESG_REPORT_FILES(reportId, proof.fileId),
      { responseType: "blob" },
    );
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = proof.name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },

  deleteFile: async (reportId, fileId) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORT_FILES(reportId, fileId),
      method: "DELETE",
    });
  },

  sendDelegation: async (reportId, payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORT_DELEGATE(reportId),
      method: "POST",
      body: payload,
      ...options,
    });
  },

  getMetricMappings: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.METRIC_MAPPINGS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  sendDelegations: async (reportId, delegations, options = {}) => {
    const data = await Promise.all(
      delegations.map((delegation) =>
        createApiRequest({
          url: ESG_ENDPOINTS.ESG_REPORT_DELEGATE(reportId),
          method: "POST",
          body: delegation,
          ...options,
        }),
      ),
    );
    return data;
  },

  getPrefillSuggestions: async (params, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_REPORT_PREFILL,
      method: "GET",
      body: params,
      ...options,
    });
  },
};
